module.exports = __webpack_public_path__ + "img/tpc-28.7b0975af.webp";